import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { connect } from "react-redux";

import { Api } from "@api/index";
import { ApiButton } from "@api/components/ApiButton";
import { connectToApi, ApiConnectedOwnProps } from "@api/components/connectToApi";
import { AuthState } from "@auth/models";
import { FilesState } from "@files/models";
import { MusicState } from "@music/models";
import { Alert } from "@ui/Alert";
import { compose } from "@util/compose";
import { REPORT_TYPE_STATEMENT_IDS } from "../../constants";
import { messages } from "../../messages";
import { Report, ReportsState } from "../../models";
import {
    getStatementsList,
    hasMoreStatementsPages,
    getNextStatementsPage,
    getLastLoadedStatements,
} from "../../selectors";
import { ReportTable } from "../ReportTable";

type State = ReportsState & FilesState & MusicState & AuthState;

interface StatementsListStateProps extends ApiConnectedOwnProps {
    reports: Report[];
    morePages: boolean;
    nextPage: number;
}

type Props = StatementsListStateProps;

const StatementsList = ({ reports, morePages, nextPage }: Props) => {
    const intl = useIntl();
    const loadMore = () => Api.reportsIndex(nextPage, { typeIds: REPORT_TYPE_STATEMENT_IDS });

    return (
        <div className="statements-list">
            <Alert style="info">
                <FormattedMessage {...messages.statementsInfo} />
            </Alert>
            <ReportTable
                key="card-list"
                reports={reports}
                intl={intl}
            ></ReportTable>
            {morePages &&
                <div className="statements-list__load-more">
                    <ApiButton actionCreators={[loadMore]}>
                        <FormattedMessage {...messages.loadMoreStatements} />
                    </ApiButton>
                </div>
            }
        </div>
    );
};

const mapStateToProps = (state: State): StatementsListStateProps => ({
    reports: getStatementsList(state),
    morePages: hasMoreStatementsPages(state),
    nextPage: getNextStatementsPage(state),
    lastLoaded: [getLastLoadedStatements(state)],
});

export const reportsIndex = () => Api.reportsIndex(1, { typeIds: REPORT_TYPE_STATEMENT_IDS });
const ConnectedStatementsList = compose<Props, {}>(
    connect(mapStateToProps, null),
    connectToApi({
        actionCreators: [reportsIndex],
        showRefresh: true,
    }),
)(StatementsList);

export {
    StatementsList as StatementsListPresenter,
    ConnectedStatementsList as StatementsList,
    Props as StatementsListProps,
    StatementsListStateProps,
};
